import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Lock, Trophy } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export function RankingLockedCard({ onUpgradeClick }) {
  const { t } = useTranslation('achievements');

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2, ease: 'easeOut' }}
    >
      <Card className="border-slate-200/60 bg-gradient-to-br from-slate-50 to-white">
        <CardContent className="p-5">
          <div className="flex items-start justify-between gap-2">
            <div className="space-y-1">
              <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500">
                <Lock className="h-3 w-3" />
                {t('rankingLocked')}
              </p>
              <p className="text-sm leading-snug text-slate-600">
                {t('rankingLockedDescription')}
              </p>
            </div>
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-slate-300 to-slate-400 text-white shadow-sm">
              <Trophy className="h-5 w-5" />
            </div>
          </div>

          <button
            type="button"
            onClick={onUpgradeClick}
            className="mt-4 w-full rounded-lg bg-gradient-to-r from-blue-500 to-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:from-blue-600 hover:to-indigo-700"
          >
            {t('upgradeToUnlock')}
          </button>
        </CardContent>
      </Card>
    </motion.div>
  );
}

export default RankingLockedCard;
